import { render } from "./AdminRedEnvelope.vue?vue&type=template&id=82a1afea"
import script from "./AdminRedEnvelope.vue?vue&type=script&lang=js"
export * from "./AdminRedEnvelope.vue?vue&type=script&lang=js"

import "./AdminRedEnvelope.vue?vue&type=style&index=0&id=82a1afea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__